module.exports = __webpack_public_path__ + "img/ic_32_sport_volleyball.be4985d6.svg";